<template>
  <v-container fluid v-if="show">
    <v-dialog v-model="show" max-width="400px" v-if="collection">
      <v-card>
        <v-card-title class="secondary white--text d-flex align-center justify-space-between">
          <span class="header-font" style="font-size: 22px;">
            <v-icon style="font-size: 18px;" color="white" class="mr-2">create_new_folder</v-icon>
            {{ $t(title) }}
          </span>
        </v-card-title>
        <v-card-text class="mt-5">
          <v-container class="pt-0">
            <v-form name="form" ref="formRef" @submit.prevent="onSaveClick">
              <v-row align="center">
                <v-col cols="12" class="pa-0">
                  <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('collections.name') }}</p>
                  <v-text-field dense hide-details outlined class="slim-input"
                    v-model="collection.name"
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0 mt-4">
                  <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('collections.visibility') }}</p>
                  <v-select dense hide-details outlined class="slim-input"
                    v-model="privacityCollectionModel"
                    :items="privacityCollectionOptionsFiltered"
                    :rules="visibilityRules"
                    item-text="label"
                  >
                    <template v-slot:item="{item}">
                      <v-list-item dense ripple>
                        <v-list-item-icon>
                          <v-icon small v-text="item.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 primary--text">{{item.label}}</v-list-item-title>
                          <v-list-item-subtitle class="body-2 primary--text subheader-font">{{item.description}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-6 pb-4 d-flex justify-end">
          <v-btn color="secondary" rounded outlined class="elevation-0 monospace-font px-4" @click="show = false">{{$t('general.cancel')}}</v-btn>
          <v-btn
            rounded class="elevation-0 monospace-font white--text px-4" color="primary"
            @click="onSaveClick()"
          >{{$t('general.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CollectionService from "../../services/collection.service";
import Dictionary from "../../dictionary";
import * as _ from "lodash";
import * as moment from "moment";

export default {
  name: "CollectionFormModal",
  components: {},
  filters: {
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    privacityCollectionOptionsFiltered(){
      switch (this.currentUser.userType){
        //Just show supervised collections for this types of users
        case "Ownership":
        case "SportingDirector":
        case "Coach":
        case "Individual":
        case "Scout":
          return this.privacityCollectionOptions;
        default:
          return this.privacityCollectionOptions.filter(pc=> pc.value != 2);
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      collection: null,
      show: false,
      privacityCollectionOptions: [
        {
          label: Dictionary[this.$i18n.locale]["collections"]["privacity"]["publicTitle"],
          description: Dictionary[this.$i18n.locale]["collections"]["privacity"]["publicDescription"],
          value: 1,
          icon: "public"
        },
        {
          label: Dictionary[this.$i18n.locale]["collections"]["privacity"]["supervisedTitle"],
          description: Dictionary[this.$i18n.locale]["collections"]["privacity"]["supervisedDescription"],
          value: 2,
          icon: "visibility"
        },
        {
          label: Dictionary[this.$i18n.locale]["collections"]["privacity"]["privateTitle"],
          description: Dictionary[this.$i18n.locale]["collections"]["privacity"]["privateDescription"],
          value: 3,
          icon: "lock"
        }
      ],
      privacityCollectionModel: 1,
      nameRules: [
        v =>
          !!v ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["required"]
      ],
      visibilityRules: [
        v =>
          v != null ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["required"]
      ]
    };
  },
  created() {},
  methods: {
    open(collection = {}) {
      this.collection = collection;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    async onSaveClick() {
      if (this.$refs.formRef.validate()) {
        this.collection.public = false;
        this.collection.supervised = false;

        switch (this.privacityCollectionModel){
          //Public
          case 1:
            this.collection.public = true;
            break;
          //Supervised
          case 2:
            this.collection.supervised = true;
            break;
          //Private
          case 3:
          default:
            break;
        }
        this.$emit("save", this.collection);
        this.collection = null;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/collections/CollectionFormModal.vue